// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_module = require("rescript/lib/js/caml_module.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../../bs-macros-extension/src/DOM__Element.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../../bs-macros-extension/src/DOM__HtmlElement.bs.js");
var STEM__Interfaces$SmartcutsMacros = require("./STEM__Interfaces.bs.js");

function t_encode(encoder_htmlElement, encoder_textNode, v) {
  if (v.TAG === /* HtmlElement */0) {
    return [
            "HtmlElement",
            Curry._1(encoder_htmlElement, v._0)
          ];
  } else {
    return [
            "TextNode",
            Curry._1(encoder_textNode, v._0)
          ];
  }
}

function t_decode(decoder_htmlElement, decoder_textNode, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "HtmlElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* HtmlElement */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "TextNode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(decoder_textNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TextNode */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function mapHtmlElement(x, f) {
  if (x.TAG === /* HtmlElement */0) {
    return {
            TAG: /* HtmlElement */0,
            _0: Curry._1(f, x._0)
          };
  } else {
    return {
            TAG: /* TextNode */1,
            _0: x._0
          };
  }
}

function mapTextNode(x, f) {
  if (x.TAG === /* HtmlElement */0) {
    return {
            TAG: /* HtmlElement */0,
            _0: x._0
          };
  } else {
    return {
            TAG: /* TextNode */1,
            _0: Curry._1(f, x._0)
          };
  }
}

function parentElement(x) {
  return Caml_option.nullable_to_opt(x._0.parentElement);
}

function isTextNode(x) {
  if (x.TAG === /* HtmlElement */0) {
    return false;
  } else {
    return true;
  }
}

function isHtmlElementSatisfying(x, predicate) {
  if (x.TAG === /* HtmlElement */0) {
    return Curry._1(predicate, x._0);
  } else {
    return false;
  }
}

function isSiblingOf(htmlElementOrText1, htmlElementOrText2) {
  var element;
  var textNode;
  if (htmlElementOrText1.TAG === /* HtmlElement */0) {
    var element1 = htmlElementOrText1._0;
    if (htmlElementOrText2.TAG === /* HtmlElement */0) {
      return DOM__HtmlElement$SmartcutsMacros.isSiblingOf(htmlElementOrText2._0, element1);
    }
    element = element1;
    textNode = htmlElementOrText2._0;
  } else {
    var textNode1 = htmlElementOrText1._0;
    if (htmlElementOrText2.TAG === /* HtmlElement */0) {
      element = htmlElementOrText2._0;
      textNode = textNode1;
    } else {
      var match = textNode1.parentElement;
      var match$1 = htmlElementOrText2._0.parentElement;
      if (!(match == null) && !(match$1 == null)) {
        return DOM__Element$SmartcutsMacros.isSiblingOf(match$1, match);
      } else {
        return false;
      }
    }
  }
  var parentElementOfTextNode = textNode.parentElement;
  if (parentElementOfTextNode == null) {
    return false;
  } else {
    return DOM__Element$SmartcutsMacros.isSiblingOf(parentElementOfTextNode, element);
  }
}

var DomHtmlElementOrTextNode = {
  t_encode: t_encode,
  t_decode: t_decode,
  mapHtmlElement: mapHtmlElement,
  mapTextNode: mapTextNode,
  parentElement: parentElement,
  isTextNode: isTextNode,
  isHtmlElementSatisfying: isHtmlElementSatisfying,
  isSiblingOf: isSiblingOf
};

var t_encode$1 = Decco.intToJson;

var t_decode$1 = Decco.intFromJson;

function fromInt(i) {
  return i;
}

function stringify(prim) {
  return String(prim);
}

var DataNodeId = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromInt: fromInt,
  stringify: stringify
};

var Record = Caml_module.init_mod([
      "DataExtraction__DataRecord__Types.re",
      114,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

var RecordProperty = Caml_module.init_mod([
      "DataExtraction__DataRecord__Types.re",
      159,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "mapDataNode"
        ]
      ]
    });

var DataNode = Caml_module.init_mod([
      "DataExtraction__DataRecord__Types.re",
      266,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "value_encode"
        ],
        [
          /* Function */0,
          "value_decode"
        ],
        [
          /* Function */0,
          "combineValues"
        ],
        [
          /* Function */0,
          "mapValue"
        ],
        [
          /* Function */0,
          "map"
        ],
        [
          /* Function */0,
          "allNodes"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ]
            ]
          },
          "WithDomElementOrTextNode"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ],
              [
                /* Function */0,
                "fromDataNodeWithDomElementOrTextNode"
              ]
            ]
          },
          "WithDomEntities"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "fromDataNodeWithDomEntities"
              ],
              [
                /* Function */0,
                "mapHtmlTagPathIdentifier"
              ]
            ]
          },
          "WithHtmlElementAndHTPI"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ],
              [
                /* Function */0,
                "mapHtmlElement"
              ],
              [
                /* Function */0,
                "mapTextNode"
              ]
            ]
          },
          "WithHtmlElementAndHTPIAndTagPathAndDataNodeId"
        ]
      ]
    });

var ImageNode = Caml_module.init_mod([
      "DataExtraction__DataRecord__Types.re",
      629,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ]
            ]
          },
          "Source"
        ],
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ]
      ]
    });

var LinkNode = Caml_module.init_mod([
      "DataExtraction__DataRecord__Types.re",
      658,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

var HeadlineNode = Caml_module.init_mod([
      "DataExtraction__DataRecord__Types.re",
      683,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

var ButtonNode = Caml_module.init_mod([
      "DataExtraction__DataRecord__Types.re",
      708,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

var ArrayNode = Caml_module.init_mod([
      "DataExtraction__DataRecord__Types.re",
      735,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    });

function t_encode$2(encoder_dataNode, v) {
  return Js_dict.fromArray([
              [
                "friendlyName",
                Decco.optionToJson(Decco.stringToJson, v.friendlyName)
              ],
              [
                "properties",
                Decco.arrayToJson(Curry._1(RecordProperty.t_encode, encoder_dataNode), v.properties)
              ]
            ]);
}

function t_decode$2(decoder_dataNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
  if (friendlyName.TAG === /* Ok */0) {
    var properties = Decco.arrayFromJson(Curry._1(RecordProperty.t_decode, decoder_dataNode), Belt_Option.getWithDefault(Js_dict.get(dict$1, "properties"), null));
    if (properties.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                friendlyName: friendlyName._0,
                properties: properties._0
              }
            };
    }
    var e = properties._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".properties" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = friendlyName._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function map(f, param) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, (function (param) {
                  return {
                          friendlyName: param.friendlyName,
                          dataNode: Curry._1(f, param.dataNode)
                        };
                }))
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, Record, {
      t_encode: t_encode$2,
      t_decode: t_decode$2,
      map: map
    });

function t_encode$3(encoder_dataNode, v) {
  return Js_dict.fromArray([
              [
                "friendlyName",
                Decco.optionToJson(Decco.stringToJson, v.friendlyName)
              ],
              [
                "dataNode",
                Curry._1(encoder_dataNode, v.dataNode)
              ]
            ]);
}

function t_decode$3(decoder_dataNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
  if (friendlyName.TAG === /* Ok */0) {
    var dataNode = Curry._1(decoder_dataNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNode"), null));
    if (dataNode.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                friendlyName: friendlyName._0,
                dataNode: dataNode._0
              }
            };
    }
    var e = dataNode._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dataNode" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = friendlyName._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function mapDataNode(param, f) {
  return {
          friendlyName: param.friendlyName,
          dataNode: Curry._1(f, param.dataNode)
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "mapDataNode"
        ]
      ]
    }, RecordProperty, {
      t_encode: t_encode$3,
      t_decode: t_decode$3,
      mapDataNode: mapDataNode
    });

function value_encode(encoder_dataNode, v) {
  switch (v.TAG | 0) {
    case /* PlainText */0 :
        return [
                "PlainText",
                Decco.stringToJson(v._0)
              ];
    case /* Image */1 :
        return [
                "Image",
                Curry._1(ImageNode.t_encode, v._0)
              ];
    case /* Link */2 :
        return [
                "Link",
                Curry._2(LinkNode.t_encode, encoder_dataNode, v._0)
              ];
    case /* LinkContainingManyProperties */3 :
        return [
                "LinkContainingManyProperties",
                Decco.stringToJson(v._0)
              ];
    case /* Headline */4 :
        return [
                "Headline",
                Curry._2(HeadlineNode.t_encode, encoder_dataNode, v._0)
              ];
    case /* Button */5 :
        return [
                "Button",
                Curry._2(ButtonNode.t_encode, encoder_dataNode, v._0)
              ];
    case /* Array */6 :
        return [
                "Array",
                Curry._2(ArrayNode.t_encode, encoder_dataNode, v._0)
              ];
    
  }
}

function value_decode(decoder_dataNode, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Array" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._2(ArrayNode.t_decode, decoder_dataNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Array */6,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Button" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._2(ButtonNode.t_decode, decoder_dataNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Button */5,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Headline" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._2(HeadlineNode.t_decode, decoder_dataNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Headline */4,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Image" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._1(ImageNode.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Image */1,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Link" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Curry._2(LinkNode.t_decode, decoder_dataNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Link */2,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "LinkContainingManyProperties" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* LinkContainingManyProperties */3,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "PlainText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PlainText */0,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function combineValues(value1, value2) {
  switch (value1.TAG | 0) {
    case /* PlainText */0 :
        if (value2.TAG === /* PlainText */0) {
          return {
                  TAG: /* Array */6,
                  _0: {
                    TAG: /* PlainTexts */0,
                    _0: [
                      value1._0,
                      value2._0
                    ]
                  }
                };
        }
        break;
    case /* Image */1 :
        if (value2.TAG === /* Image */1) {
          return {
                  TAG: /* Array */6,
                  _0: {
                    TAG: /* Images */1,
                    _0: [
                      value1._0,
                      value2._0
                    ]
                  }
                };
        }
        break;
    case /* Link */2 :
        if (value2.TAG === /* Link */2) {
          return {
                  TAG: /* Array */6,
                  _0: {
                    TAG: /* Links */2,
                    _0: [
                      value1._0,
                      value2._0
                    ]
                  }
                };
        }
        break;
    case /* LinkContainingManyProperties */3 :
        break;
    case /* Headline */4 :
        if (value2.TAG === /* Headline */4) {
          return {
                  TAG: /* Array */6,
                  _0: {
                    TAG: /* Headlines */3,
                    _0: [
                      value1._0,
                      value2._0
                    ]
                  }
                };
        }
        break;
    case /* Button */5 :
        if (value2.TAG === /* Button */5) {
          return {
                  TAG: /* Array */6,
                  _0: {
                    TAG: /* Buttons */4,
                    _0: [
                      value1._0,
                      value2._0
                    ]
                  }
                };
        }
        break;
    case /* Array */6 :
        var texts = value1._0;
        switch (texts.TAG | 0) {
          case /* PlainTexts */0 :
              if (value2.TAG === /* PlainText */0) {
                return {
                        TAG: /* Array */6,
                        _0: {
                          TAG: /* PlainTexts */0,
                          _0: $$Array.append(texts._0, [value2._0])
                        }
                      };
              }
              break;
          case /* Images */1 :
              if (value2.TAG === /* Image */1) {
                return {
                        TAG: /* Array */6,
                        _0: {
                          TAG: /* Images */1,
                          _0: $$Array.append(texts._0, [value2._0])
                        }
                      };
              }
              break;
          case /* Links */2 :
              if (value2.TAG === /* Link */2) {
                return {
                        TAG: /* Array */6,
                        _0: {
                          TAG: /* Links */2,
                          _0: $$Array.append(texts._0, [value2._0])
                        }
                      };
              }
              break;
          case /* Headlines */3 :
              if (value2.TAG === /* Headline */4) {
                return {
                        TAG: /* Array */6,
                        _0: {
                          TAG: /* Headlines */3,
                          _0: $$Array.append(texts._0, [value2._0])
                        }
                      };
              }
              break;
          case /* Buttons */4 :
              if (value2.TAG === /* Button */5) {
                return {
                        TAG: /* Array */6,
                        _0: {
                          TAG: /* Buttons */4,
                          _0: $$Array.append(texts._0, [value2._0])
                        }
                      };
              }
              break;
          case /* Records */5 :
              break;
          
        }
        break;
    
  }
  console.warn("value1", value1);
  console.warn("value2", value2);
  return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected value combination");
}

function mapValue(value, transformDataNode) {
  switch (value.TAG | 0) {
    case /* PlainText */0 :
        return {
                TAG: /* PlainText */0,
                _0: value._0
              };
    case /* Image */1 :
        return {
                TAG: /* Image */1,
                _0: value._0
              };
    case /* Link */2 :
        return {
                TAG: /* Link */2,
                _0: Curry._2(LinkNode.map, transformDataNode, value._0)
              };
    case /* LinkContainingManyProperties */3 :
        return {
                TAG: /* LinkContainingManyProperties */3,
                _0: value._0
              };
    case /* Headline */4 :
        return {
                TAG: /* Headline */4,
                _0: Curry._2(HeadlineNode.map, transformDataNode, value._0)
              };
    case /* Button */5 :
        return {
                TAG: /* Button */5,
                _0: Curry._2(ButtonNode.map, transformDataNode, value._0)
              };
    case /* Array */6 :
        return {
                TAG: /* Array */6,
                _0: Curry._2(ArrayNode.map, transformDataNode, value._0)
              };
    
  }
}

function map$1(mapValue, dataNode) {
  var f = function (param) {
    return map$1(mapValue, param);
  };
  return Curry._2(mapValue, dataNode, (function (value) {
                switch (value.TAG | 0) {
                  case /* PlainText */0 :
                      return {
                              TAG: /* PlainText */0,
                              _0: value._0
                            };
                  case /* Image */1 :
                      return {
                              TAG: /* Image */1,
                              _0: value._0
                            };
                  case /* Link */2 :
                      return {
                              TAG: /* Link */2,
                              _0: Curry._2(LinkNode.map, f, value._0)
                            };
                  case /* LinkContainingManyProperties */3 :
                      return {
                              TAG: /* LinkContainingManyProperties */3,
                              _0: value._0
                            };
                  case /* Headline */4 :
                      return {
                              TAG: /* Headline */4,
                              _0: Curry._2(HeadlineNode.map, f, value._0)
                            };
                  case /* Button */5 :
                      return {
                              TAG: /* Button */5,
                              _0: Curry._2(ButtonNode.map, f, value._0)
                            };
                  case /* Array */6 :
                      return {
                              TAG: /* Array */6,
                              _0: Curry._2(ArrayNode.map, f, value._0)
                            };
                  
                }
              }));
}

function allNodes(dataNode, valueFromDataNode) {
  var match = Curry._1(valueFromDataNode, dataNode);
  var tmp;
  var exit = 0;
  switch (match.TAG | 0) {
    case /* Link */2 :
    case /* Headline */4 :
    case /* Button */5 :
        exit = 1;
        break;
    case /* Array */6 :
        var linkNodes = match._0;
        switch (linkNodes.TAG | 0) {
          case /* PlainTexts */0 :
          case /* Images */1 :
              tmp = [];
              break;
          case /* Links */2 :
              tmp = ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                      return ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                                    return allNodes(param, valueFromDataNode);
                                  }), param.innerContent);
                    }), linkNodes._0);
              break;
          case /* Headlines */3 :
              tmp = ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                      return ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                                    return allNodes(param, valueFromDataNode);
                                  }), param.innerContent);
                    }), linkNodes._0);
              break;
          case /* Buttons */4 :
              tmp = ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                      return ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                                    return allNodes(param, valueFromDataNode);
                                  }), param.innerContent);
                    }), linkNodes._0);
              break;
          case /* Records */5 :
              tmp = ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                      return ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                                    return allNodes(param.dataNode, valueFromDataNode);
                                  }), param.properties);
                    }), linkNodes._0);
              break;
          
        }
        break;
    default:
      tmp = [];
  }
  if (exit === 1) {
    tmp = ArrayUtils$SmartcutsMacros.flatMap((function (param) {
            return allNodes(param, valueFromDataNode);
          }), match._0.innerContent);
  }
  return Belt_Array.concat([dataNode], tmp);
}

function t_encode$4(encoder_htmlElement, encoder_textNode, v) {
  return Js_dict.fromArray([
              [
                "domElementOrTextNode",
                t_encode(encoder_htmlElement, encoder_textNode, v.domElementOrTextNode)
              ],
              [
                "value",
                value_encode((function (param) {
                        return t_encode$4(encoder_htmlElement, encoder_textNode, param);
                      }), v.value)
              ]
            ]);
}

function t_decode$4(decoder_htmlElement, decoder_textNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementOrTextNode = t_decode(decoder_htmlElement, decoder_textNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementOrTextNode"), null));
  if (domElementOrTextNode.TAG === /* Ok */0) {
    var value = value_decode((function (param) {
            return t_decode$4(decoder_htmlElement, decoder_textNode, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                domElementOrTextNode: domElementOrTextNode._0,
                value: value._0
              }
            };
    }
    var e = value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".value" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = domElementOrTextNode._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementOrTextNode" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var WithDomElementOrTextNode = {
  t_encode: t_encode$4,
  t_decode: t_decode$4
};

function t_encode$5(encoder_htmlElement, encoder_textNode, v) {
  return Js_dict.fromArray([
              [
                "domEntities",
                Decco.arrayToJson((function (param) {
                        return t_encode(encoder_htmlElement, encoder_textNode, param);
                      }), v.domEntities)
              ],
              [
                "value",
                value_encode((function (param) {
                        return t_encode$5(encoder_htmlElement, encoder_textNode, param);
                      }), v.value)
              ]
            ]);
}

function t_decode$5(decoder_htmlElement, decoder_textNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domEntities = Decco.arrayFromJson((function (param) {
          return t_decode(decoder_htmlElement, decoder_textNode, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "domEntities"), null));
  if (domEntities.TAG === /* Ok */0) {
    var value = value_decode((function (param) {
            return t_decode$5(decoder_htmlElement, decoder_textNode, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                domEntities: domEntities._0,
                value: value._0
              }
            };
    }
    var e = value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".value" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = domEntities._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domEntities" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromDataNodeWithDomElementOrTextNode(dataNodeWithDomElementOrTextNode) {
  var transformDataNode = function (param) {
    return {
            domEntities: [param.domElementOrTextNode],
            value: Curry._2(DataNode.mapValue, param.value, transformDataNode)
          };
  };
  return transformDataNode(dataNodeWithDomElementOrTextNode);
}

var WithDomEntities = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  fromDataNodeWithDomElementOrTextNode: fromDataNodeWithDomElementOrTextNode
};

function fromDataNodeWithDomEntities(dataNodeWithDomEntities, lookupTable) {
  return map$1((function (param, f) {
                var domEntities = param.domEntities;
                var htmlElement = Belt_Array.getExn(domEntities, 0);
                var tmp;
                tmp = htmlElement.TAG === /* HtmlElement */0 ? List.assoc(htmlElement._0, lookupTable) : List.assoc(Belt_Option.getExn(Caml_option.nullable_to_opt(htmlElement._0.parentElement)), lookupTable);
                return {
                        htmlTagPathIdentifier: tmp,
                        domEntities: domEntities,
                        value: Curry._1(f, param.value)
                      };
              }), dataNodeWithDomEntities);
}

function mapHtmlTagPathIdentifier(param, f) {
  var value = param.value;
  var tmp;
  switch (value.TAG | 0) {
    case /* Link */2 :
        tmp = {
          TAG: /* Link */2,
          _0: Curry._2(LinkNode.map, (function (nestedDataNode) {
                  return mapHtmlTagPathIdentifier(nestedDataNode, f);
                }), value._0)
        };
        break;
    case /* Headline */4 :
        tmp = {
          TAG: /* Headline */4,
          _0: Curry._2(HeadlineNode.map, (function (nestedDataNode) {
                  return mapHtmlTagPathIdentifier(nestedDataNode, f);
                }), value._0)
        };
        break;
    case /* Button */5 :
        tmp = {
          TAG: /* Button */5,
          _0: Curry._2(ButtonNode.map, (function (nestedDataNode) {
                  return mapHtmlTagPathIdentifier(nestedDataNode, f);
                }), value._0)
        };
        break;
    case /* Array */6 :
        tmp = {
          TAG: /* Array */6,
          _0: Curry._2(ArrayNode.map, (function (nestedDataNode) {
                  return mapHtmlTagPathIdentifier(nestedDataNode, f);
                }), value._0)
        };
        break;
    default:
      tmp = value;
  }
  return {
          htmlTagPathIdentifier: Curry._1(f, param.htmlTagPathIdentifier),
          domEntities: param.domEntities,
          value: tmp
        };
}

var WithHtmlElementAndHTPI = {
  fromDataNodeWithDomEntities: fromDataNodeWithDomEntities,
  mapHtmlTagPathIdentifier: mapHtmlTagPathIdentifier
};

function t_encode$6(encoder_htmlElement, encoder_textNode, v) {
  return Js_dict.fromArray([
              [
                "dataNodeId",
                Decco.intToJson(v.dataNodeId)
              ],
              [
                "htmlTagPathIdentifier",
                STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.htmlTagPathIdentifier)
              ],
              [
                "domEntities",
                Decco.arrayToJson((function (param) {
                        return t_encode(encoder_htmlElement, encoder_textNode, param);
                      }), v.domEntities)
              ],
              [
                "tagPath",
                Decco.arrayToJson(Decco.stringToJson, v.tagPath)
              ],
              [
                "value",
                value_encode((function (param) {
                        return t_encode$6(encoder_htmlElement, encoder_textNode, param);
                      }), v.value)
              ]
            ]);
}

function t_decode$6(decoder_htmlElement, decoder_textNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var dataNodeId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNodeId"), null));
  if (dataNodeId.TAG === /* Ok */0) {
    var htmlTagPathIdentifier = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifier"), null));
    if (htmlTagPathIdentifier.TAG === /* Ok */0) {
      var domEntities = Decco.arrayFromJson((function (param) {
              return t_decode(decoder_htmlElement, decoder_textNode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "domEntities"), null));
      if (domEntities.TAG === /* Ok */0) {
        var tagPath = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagPath"), null));
        if (tagPath.TAG === /* Ok */0) {
          var value = value_decode((function (param) {
                  return t_decode$6(decoder_htmlElement, decoder_textNode, param);
                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
          if (value.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      dataNodeId: dataNodeId._0,
                      htmlTagPathIdentifier: htmlTagPathIdentifier._0,
                      domEntities: domEntities._0,
                      tagPath: tagPath._0,
                      value: value._0
                    }
                  };
          }
          var e = value._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".value" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = tagPath._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".tagPath" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = domEntities._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".domEntities" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = htmlTagPathIdentifier._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".htmlTagPathIdentifier" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = dataNodeId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".dataNodeId" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function mapHtmlElement$1(param, f) {
  var value = param.value;
  var tmp;
  switch (value.TAG | 0) {
    case /* PlainText */0 :
        tmp = {
          TAG: /* PlainText */0,
          _0: value._0
        };
        break;
    case /* Image */1 :
        tmp = {
          TAG: /* Image */1,
          _0: value._0
        };
        break;
    case /* Link */2 :
        tmp = {
          TAG: /* Link */2,
          _0: Curry._2(LinkNode.map, (function (nestedDataNode) {
                  return mapHtmlElement$1(nestedDataNode, f);
                }), value._0)
        };
        break;
    case /* LinkContainingManyProperties */3 :
        tmp = {
          TAG: /* LinkContainingManyProperties */3,
          _0: value._0
        };
        break;
    case /* Headline */4 :
        tmp = {
          TAG: /* Headline */4,
          _0: Curry._2(HeadlineNode.map, (function (nestedDataNode) {
                  return mapHtmlElement$1(nestedDataNode, f);
                }), value._0)
        };
        break;
    case /* Button */5 :
        tmp = {
          TAG: /* Button */5,
          _0: Curry._2(ButtonNode.map, (function (nestedDataNode) {
                  return mapHtmlElement$1(nestedDataNode, f);
                }), value._0)
        };
        break;
    case /* Array */6 :
        tmp = {
          TAG: /* Array */6,
          _0: Curry._2(ArrayNode.map, (function (nestedDataNode) {
                  return mapHtmlElement$1(nestedDataNode, f);
                }), value._0)
        };
        break;
    
  }
  return {
          dataNodeId: param.dataNodeId,
          htmlTagPathIdentifier: param.htmlTagPathIdentifier,
          domEntities: Belt_Array.map(param.domEntities, (function (__x) {
                  return mapHtmlElement(__x, f);
                })),
          tagPath: param.tagPath,
          value: tmp
        };
}

function mapTextNode$1(param, f) {
  var value = param.value;
  var tmp;
  switch (value.TAG | 0) {
    case /* PlainText */0 :
        tmp = {
          TAG: /* PlainText */0,
          _0: value._0
        };
        break;
    case /* Image */1 :
        tmp = {
          TAG: /* Image */1,
          _0: value._0
        };
        break;
    case /* Link */2 :
        tmp = {
          TAG: /* Link */2,
          _0: Curry._2(LinkNode.map, (function (nestedDataNode) {
                  return mapTextNode$1(nestedDataNode, f);
                }), value._0)
        };
        break;
    case /* LinkContainingManyProperties */3 :
        tmp = {
          TAG: /* LinkContainingManyProperties */3,
          _0: value._0
        };
        break;
    case /* Headline */4 :
        tmp = {
          TAG: /* Headline */4,
          _0: Curry._2(HeadlineNode.map, (function (nestedDataNode) {
                  return mapTextNode$1(nestedDataNode, f);
                }), value._0)
        };
        break;
    case /* Button */5 :
        tmp = {
          TAG: /* Button */5,
          _0: Curry._2(ButtonNode.map, (function (nestedDataNode) {
                  return mapTextNode$1(nestedDataNode, f);
                }), value._0)
        };
        break;
    case /* Array */6 :
        tmp = {
          TAG: /* Array */6,
          _0: Curry._2(ArrayNode.map, (function (nestedDataNode) {
                  return mapTextNode$1(nestedDataNode, f);
                }), value._0)
        };
        break;
    
  }
  return {
          dataNodeId: param.dataNodeId,
          htmlTagPathIdentifier: param.htmlTagPathIdentifier,
          domEntities: Belt_Array.map(param.domEntities, (function (__x) {
                  return mapTextNode(__x, f);
                })),
          tagPath: param.tagPath,
          value: tmp
        };
}

var WithHtmlElementAndHTPIAndTagPathAndDataNodeId = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  mapHtmlElement: mapHtmlElement$1,
  mapTextNode: mapTextNode$1
};

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "value_encode"
        ],
        [
          /* Function */0,
          "value_decode"
        ],
        [
          /* Function */0,
          "combineValues"
        ],
        [
          /* Function */0,
          "mapValue"
        ],
        [
          /* Function */0,
          "map"
        ],
        [
          /* Function */0,
          "allNodes"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ]
            ]
          },
          "WithDomElementOrTextNode"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ],
              [
                /* Function */0,
                "fromDataNodeWithDomElementOrTextNode"
              ]
            ]
          },
          "WithDomEntities"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "fromDataNodeWithDomEntities"
              ],
              [
                /* Function */0,
                "mapHtmlTagPathIdentifier"
              ]
            ]
          },
          "WithHtmlElementAndHTPI"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ],
              [
                /* Function */0,
                "mapHtmlElement"
              ],
              [
                /* Function */0,
                "mapTextNode"
              ]
            ]
          },
          "WithHtmlElementAndHTPIAndTagPathAndDataNodeId"
        ]
      ]
    }, DataNode, {
      value_encode: value_encode,
      value_decode: value_decode,
      combineValues: combineValues,
      mapValue: mapValue,
      map: map$1,
      allNodes: allNodes,
      WithDomElementOrTextNode: WithDomElementOrTextNode,
      WithDomEntities: WithDomEntities,
      WithHtmlElementAndHTPI: WithHtmlElementAndHTPI,
      WithHtmlElementAndHTPIAndTagPathAndDataNodeId: WithHtmlElementAndHTPIAndTagPathAndDataNodeId
    });

function t_encode$7(v) {
  return Js_dict.fromArray([
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "mimeType",
                Decco.optionToJson(Decco.stringToJson, v.mimeType)
              ],
              [
                "media",
                Decco.optionToJson(Decco.stringToJson, v.media)
              ],
              [
                "widthOrPixelDensity",
                Decco.optionToJson(Decco.stringToJson, v.widthOrPixelDensity)
              ]
            ]);
}

function t_decode$7(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var mimeType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mimeType"), null));
    if (mimeType.TAG === /* Ok */0) {
      var media = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "media"), null));
      if (media.TAG === /* Ok */0) {
        var widthOrPixelDensity = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "widthOrPixelDensity"), null));
        if (widthOrPixelDensity.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    url: url._0,
                    mimeType: mimeType._0,
                    media: media._0,
                    widthOrPixelDensity: widthOrPixelDensity._0
                  }
                };
        }
        var e = widthOrPixelDensity._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".widthOrPixelDensity" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = media._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".media" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = mimeType._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".mimeType" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

var Source = {
  t_encode: t_encode$7,
  t_decode: t_decode$7
};

function t_encode$8(v) {
  return Js_dict.fromArray([
              [
                "src",
                Decco.stringToJson(v.src)
              ],
              [
                "altText",
                Decco.optionToJson(Decco.stringToJson, v.altText)
              ],
              [
                "sources",
                Decco.arrayToJson(t_encode$7, v.sources)
              ]
            ]);
}

function t_decode$8(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var src = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "src"), null));
  if (src.TAG === /* Ok */0) {
    var altText = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "altText"), null));
    if (altText.TAG === /* Ok */0) {
      var sources = Decco.arrayFromJson(t_decode$7, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sources"), null));
      if (sources.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  src: src._0,
                  altText: altText._0,
                  sources: sources._0
                }
              };
      }
      var e = sources._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".sources" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = altText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".altText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = src._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".src" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ]
            ]
          },
          "Source"
        ],
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ]
      ]
    }, ImageNode, {
      Source: Source,
      t_encode: t_encode$8,
      t_decode: t_decode$8
    });

function t_encode$9(encoder_dataNode, v) {
  return Js_dict.fromArray([
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "innerText",
                Decco.stringToJson(v.innerText)
              ],
              [
                "innerContent",
                Decco.arrayToJson(encoder_dataNode, v.innerContent)
              ]
            ]);
}

function t_decode$9(decoder_dataNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var innerText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerText"), null));
    if (innerText.TAG === /* Ok */0) {
      var innerContent = Decco.arrayFromJson(decoder_dataNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerContent"), null));
      if (innerContent.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  url: url._0,
                  innerText: innerText._0,
                  innerContent: innerContent._0
                }
              };
      }
      var e = innerContent._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".innerContent" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = innerText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".innerText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function map$2(f, param) {
  return {
          url: param.url,
          innerText: param.innerText,
          innerContent: Belt_Array.map(param.innerContent, f)
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, LinkNode, {
      t_encode: t_encode$9,
      t_decode: t_decode$9,
      map: map$2
    });

function t_encode$10(encoder_dataNode, v) {
  return Js_dict.fromArray([
              [
                "hLevel",
                Decco.stringToJson(v.hLevel)
              ],
              [
                "innerText",
                Decco.stringToJson(v.innerText)
              ],
              [
                "innerContent",
                Decco.arrayToJson(encoder_dataNode, v.innerContent)
              ]
            ]);
}

function t_decode$10(decoder_dataNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var hLevel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hLevel"), null));
  if (hLevel.TAG === /* Ok */0) {
    var innerText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerText"), null));
    if (innerText.TAG === /* Ok */0) {
      var innerContent = Decco.arrayFromJson(decoder_dataNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerContent"), null));
      if (innerContent.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  hLevel: hLevel._0,
                  innerText: innerText._0,
                  innerContent: innerContent._0
                }
              };
      }
      var e = innerContent._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".innerContent" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = innerText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".innerText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = hLevel._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".hLevel" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function map$3(f, param) {
  return {
          hLevel: param.hLevel,
          innerText: param.innerText,
          innerContent: Belt_Array.map(param.innerContent, f)
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, HeadlineNode, {
      t_encode: t_encode$10,
      t_decode: t_decode$10,
      map: map$3
    });

function t_encode$11(encoder_dataNode, v) {
  return Js_dict.fromArray([
              [
                "maybeHref",
                Decco.optionToJson(Decco.stringToJson, v.maybeHref)
              ],
              [
                "innerText",
                Decco.stringToJson(v.innerText)
              ],
              [
                "innerContent",
                Decco.arrayToJson(encoder_dataNode, v.innerContent)
              ]
            ]);
}

function t_decode$11(decoder_dataNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var maybeHref = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeHref"), null));
  if (maybeHref.TAG === /* Ok */0) {
    var innerText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerText"), null));
    if (innerText.TAG === /* Ok */0) {
      var innerContent = Decco.arrayFromJson(decoder_dataNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerContent"), null));
      if (innerContent.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  maybeHref: maybeHref._0,
                  innerText: innerText._0,
                  innerContent: innerContent._0
                }
              };
      }
      var e = innerContent._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".innerContent" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = innerText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".innerText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = maybeHref._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".maybeHref" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function map$4(f, param) {
  return {
          maybeHref: param.maybeHref,
          innerText: param.innerText,
          innerContent: Belt_Array.map(param.innerContent, f)
        };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, ButtonNode, {
      t_encode: t_encode$11,
      t_decode: t_decode$11,
      map: map$4
    });

function t_encode$12(encoder_dataNode, v) {
  switch (v.TAG | 0) {
    case /* PlainTexts */0 :
        return [
                "PlainTexts",
                Decco.arrayToJson(Decco.stringToJson, v._0)
              ];
    case /* Images */1 :
        return [
                "Images",
                Decco.arrayToJson(ImageNode.t_encode, v._0)
              ];
    case /* Links */2 :
        return [
                "Links",
                Decco.arrayToJson(Curry._1(LinkNode.t_encode, encoder_dataNode), v._0)
              ];
    case /* Headlines */3 :
        return [
                "Headlines",
                Decco.arrayToJson(Curry._1(HeadlineNode.t_encode, encoder_dataNode), v._0)
              ];
    case /* Buttons */4 :
        return [
                "Buttons",
                Decco.arrayToJson(Curry._1(ButtonNode.t_encode, encoder_dataNode), v._0)
              ];
    case /* Records */5 :
        return [
                "Records",
                Decco.arrayToJson(Curry._1(Record.t_encode, encoder_dataNode), v._0)
              ];
    
  }
}

function t_decode$12(decoder_dataNode, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Buttons" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(Curry._1(ButtonNode.t_decode, decoder_dataNode), Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Buttons */4,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Headlines" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.arrayFromJson(Curry._1(HeadlineNode.t_decode, decoder_dataNode), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Headlines */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Images" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.arrayFromJson(ImageNode.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Images */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Links" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.arrayFromJson(Curry._1(LinkNode.t_decode, decoder_dataNode), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Links */2,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "PlainTexts" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PlainTexts */0,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "Records" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Decco.arrayFromJson(Curry._1(Record.t_decode, decoder_dataNode), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Records */5,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function map$5(f, arrayNode) {
  switch (arrayNode.TAG | 0) {
    case /* PlainTexts */0 :
        return {
                TAG: /* PlainTexts */0,
                _0: arrayNode._0
              };
    case /* Images */1 :
        return {
                TAG: /* Images */1,
                _0: arrayNode._0
              };
    case /* Links */2 :
        return {
                TAG: /* Links */2,
                _0: Belt_Array.map(arrayNode._0, Curry._1(LinkNode.map, f))
              };
    case /* Headlines */3 :
        return {
                TAG: /* Headlines */3,
                _0: Belt_Array.map(arrayNode._0, Curry._1(HeadlineNode.map, f))
              };
    case /* Buttons */4 :
        return {
                TAG: /* Buttons */4,
                _0: Belt_Array.map(arrayNode._0, Curry._1(ButtonNode.map, f))
              };
    case /* Records */5 :
        return {
                TAG: /* Records */5,
                _0: Belt_Array.map(arrayNode._0, Curry._1(Record.map, f))
              };
    
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "map"
        ]
      ]
    }, ArrayNode, {
      t_encode: t_encode$12,
      t_decode: t_decode$12,
      map: map$5
    });

exports.DomHtmlElementOrTextNode = DomHtmlElementOrTextNode;
exports.DataNodeId = DataNodeId;
exports.Record = Record;
exports.RecordProperty = RecordProperty;
exports.DataNode = DataNode;
exports.ImageNode = ImageNode;
exports.LinkNode = LinkNode;
exports.HeadlineNode = HeadlineNode;
exports.ButtonNode = ButtonNode;
exports.ArrayNode = ArrayNode;
/* Record Not a pure module */
